import { BaseService } from "services/_baseService";

class AirlinesAdminService extends BaseService<any> {
  constructor() {
    super(`airlines`);
  }
}

export default new AirlinesAdminService();
